export default "/images/42d54813a0dce204e79fcfcb07166cd1.png";